import styled from "styled-components";
import { CaretDownMenuIcon } from "~components/Icons";

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const SelectorButton = styled.div<{ $invertColors?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 204px;
  height: 36px;
  border-radius: 100px;
  padding: 16px 20px;
  background: ${({ $invertColors }) => ($invertColors ? "#474747" : "#333333")};
  cursor: pointer;
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.grey[0]};
  transition: background-color 0.2s ease-in-out;

`;

export const SelectorText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Icon = styled(CaretDownMenuIcon)`
  flex-shrink: 0;
  margin-left: 8px;
`;

export const Dropdown = styled.div<{ $isOpened: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  display: ${({ $isOpened }) => ($isOpened ? "block" : "none")};
  z-index: 12;
  background-color: ${({ theme }) => theme.palette.grey[700]};
  color: ${({ theme }) => theme.palette.grey[0]};
  width: 204px;
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  padding: 20px;
  text-align: left;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  
  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.palette.grey[800]};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.grey[500]};
    border-radius: 3px;
    
    &:hover {
      background: ${({ theme }) => theme.palette.grey[400]};
    }
  }
`;

export const StreamLabel = styled.p<{ $isSelected: boolean }>`
  margin: 0;
  color: ${({ $isSelected }) => ($isSelected ? "#00AB55" : "inherit")};
  cursor: pointer;
  font-size: 15px;
  font-weight: ${({ $isSelected }) => ($isSelected ? "bold" : "inherit")};
  line-height: 1.2;
  padding: 8px 0;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;

  &:hover {
    color: #00ab55;
    font-weight: bold;
  }
`;

export const StreamBrandName = styled.span`
  font-size: 15px;
  line-height: 1.2;
`;

export const StreamName = styled.span`
  font-size: 11px;
  line-height: 1.2;
  margin-top: 4px;
  opacity: 0.8;
`;

export const AddBrandLabel = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.grey[0]};
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  line-height: 48px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.palette.grey[0]};
    font-weight: bold;
  }
`;
